export default "__VITE_ASSET__bb0f23c9__"